<template>
  <b-modal
    ref="modal"
    title="Chọn lại gói hóa đơn điện tử"
    @ok="handleSubmit"
    ok-title="Xác nhận"
    cancel-title="Hủy"
    :ok-disabled="submitting || !isFormValid"
    no-close-on-backdrop
    no-close-on-esc
  >
    <div class="form-group">
      <label for="packageSelect">Chọn gói <span class="text-danger">*</span></label>
      <select
        id="packageSelect"
        v-model="selectedPackageCode"
        class="form-control"
        :disabled="submitting || loadingPackages"
      >
        <option value="">-- Chọn gói --</option>
        <option v-for="pkg in packages" :key="pkg.code" :value="pkg.code">
          {{ pkg.name }} - {{ formatCurrency(pkg.price) }}
        </option>
      </select>
      <div v-if="packagesError" class="invalid-feedback d-block">{{ packagesError }}</div>
    </div>
    <div class="form-group" v-if="selectedPackage">
      <label class="form-label">Thông tin gói đã chọn</label>
      <div class="note-content">
        <div><strong>Tên:</strong> {{ selectedPackage.name }}</div>
        <!-- <div><strong>Mã:</strong> {{ selectedPackage.code }}</div> -->
        <div v-if="selectedPackage.price">
          <strong>Giá:</strong> {{ formatCurrency(selectedPackage.price) }}
        </div>
        <div v-if="selectedPackage.descriptions && selectedPackage.descriptions.length">
          <strong>Mô tả:</strong>
          <ul style="margin: 0; padding-left: 18px">
            <li v-for="(d, i) in selectedPackage.descriptions" :key="i">{{ d }}</li>
          </ul>
        </div>
      </div>
    </div>
    <div class="form-group">
      <label for="noteInput">Lý do <span class="text-danger">*</span></label>
      <textarea
        id="noteInput"
        v-model="note"
        class="form-control"
        rows="3"
        placeholder="Nhập lý do chọn lại gói..."
        :disabled="submitting"
      ></textarea>
    </div>
  </b-modal>
</template>

<script>
  import { ComboService } from '@/services/combo.service'
  import { showMess } from '@/config/utils'

  export default {
    name: 'UpdatePackagePopup',
    props: {
      id: {
        type: String,
        required: true,
      },
      currentPackageCode: {
        type: String,
        default: '',
      },
      currentPackageName: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        form: {
          packageCode: this.currentPackageCode,
          packageName: this.currentPackageName,
        },
        packages: [],
        loadingPackages: false,
        packagesError: '',
        selectedPackageCode: this.currentPackageCode || '',
        note: '',
        submitting: false,
      }
    },
    computed: {
      isFormValid() {
        return (
          this.selectedPackageCode &&
          this.selectedPackageCode.trim() &&
          this.note &&
          this.note.trim()
        )
      },
      selectedPackage() {
        return this.packages.find(p => p.code === this.selectedPackageCode) || null
      },
    },
    watch: {
      currentPackageCode(val) {
        this.form.packageCode = val
        this.selectedPackageCode = val
      },
      currentPackageName(val) {
        this.form.packageName = val
      },
    },
    methods: {
      // show the modal via ref; optional initialData to preselect
      show(initialData = {}) {
        this.packagesError = ''
        this.submitting = false
        this.note = ''
        this.selectedPackageCode =
          (initialData.invoicePackage && initialData.invoicePackage.code) ||
          this.currentPackageCode ||
          ''
        // load packages fresh
        this.loadPackages()
        this.$nextTick(() => {
          this.$refs.modal && this.$refs.modal.show()
        })
      },
      formatCurrency(val) {
        try {
          return val.toLocaleString('vi-VN', { style: 'currency', currency: 'VND' })
        } catch (e) {
          return val
        }
      },
      async loadPackages() {
        try {
          this.loadingPackages = true
          const resp = await ComboService.listPackages({})
          const list = resp?.data || resp
          this.packages = Array.isArray(list) ? list : []
        } catch (err) {
          this.packagesError = err?.message || 'Không tải được danh sách gói'
        } finally {
          this.loadingPackages = false
        }
      },

      async handleSubmit() {
        if (!this.isFormValid) return
        const pkg = this.selectedPackage
        if (!pkg) return
        this.submitting = true
        try {
          const res = await ComboService.updatePackage({
            id: this.id,
            packageId: pkg.id,
            packageCode: pkg.code,
            packageName: pkg.name,
            note: this.note,
          })
          if (res && res.code === 1000) {
            showMess(
              this,
              'Thành công',
              'Cập nhật gói thành công',
              'success',
              'b-toaster-top-right',
              3000
            )
            this.$emit('updated')
            // hide modal
            this.$refs.modal && this.$refs.modal.hide()
          } else {
            const msg = res?.message || 'Cập nhật gói thất bại'
            showMess(this, 'Thất bại', msg, 'danger', 'b-toaster-top-right', 3000)
            this.$emit('error', res)
          }
        } catch (e) {
          showMess(
            this,
            'Lỗi',
            e?.message || 'Có lỗi xảy ra',
            'danger',
            'b-toaster-top-right',
            5000
          )
          this.$emit('error', e)
        } finally {
          this.submitting = false
        }
      },
    },
    mounted() {
      this.loadPackages()
    },
  }
</script>

<style scoped></style>
